export const timestampToTextFromSeconds = (
  timestampInSeconds: number,
): string => {
  const date = new Date(parseInt(`${timestampInSeconds}`) * 1000);
  return date.toDateString();
};
